module.exports = __webpack_public_path__ + "img/22_25.e60b8dcf.png";